import {useEffect, useRef} from 'react';

export type UseTimeoutParams = {
	timeout?: number;
};

export const useTimeout = ({timeout: _timeout}: UseTimeoutParams = {}) => {
	const timeoutRef = useRef<NodeJS.Timeout>();

	useEffect(() => {
		return () => {
			timeoutRef.current && clearTimeout(timeoutRef.current);
		};
	}, []);

	const cancelTimeout = () => {
		timeoutRef.current && clearTimeout(timeoutRef.current);
	};

	const executeTimeout = (cb: () => void, timeout?: number) => {
		timeout = timeout ?? _timeout ?? 0;
		cancelTimeout;
		timeoutRef.current = setTimeout(cb, timeout);
	};

	return {
		cancelTimeout,
		executeTimeout,
	};
};
